import { Fragment, useEffect, useState } from 'react';
import Textfield from '../../components/inputs/textfield';
import Button from '../../components/ui/button';
import useGlobal from '../../../store';
import { useNavigate } from 'react-router-dom';
import validateEmail from '../../scripts/helpers/validate.email';
import './auth.scss';

const AuthPage = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { sign } = globalActions;

  const navigate = useNavigate();

  const [ mail, setMail ] = useState('');
  const [ pass, setPass ] = useState('');
  const [ error, setError ] = useState ("");

  const isFormValidated = validateEmail( mail ) && pass !== "";

  function handleSignIn() {

    const goToApp = () => navigate( '/' );
    sign.In( mail, pass, goToApp, setError );

  }

  useEffect( () => { error !== "" && setError(""); }, [ mail, pass ] );

  return (

    <div className = 'container auth flex column items-center relative'>

      <p className = 'text-center auth__title'>Авторизация</p>

      <Textfield

        value = { mail }
        set = { setMail }
        title = 'Электронная почта'
        placeholder = 'Введите почту'

      />

      <Textfield

        value = { pass }
        set = { setPass }
        title = 'Пароль'
        placeholder = 'Введите пароль'

      />

      { error !== "" && <Fragment><p className = "auth__error">{ error }</p></Fragment> }

      <Button

        action = { handleSignIn }
        className = 'auth__button' disabled = { !isFormValidated }
        
      >

        Войти

      </Button>

    </div>

  );

};

export default AuthPage;